var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107.113,
    height: 38.338,
    viewBox: "0 0 107.113 38.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M250.647,721.551l-5.518-9.557H234.094l-4.26,7.38a1.452,1.452,0,0,1-2.514,0l-4.261-7.38-5.518-9.557-5.518,9.557-5.518,9.557-5.518,9.557h11.036l4.26-7.379a1.452,1.452,0,0,1,2.514,0l4.26,7.379,5.518,9.557,5.518-9.557h11.036l-5.518-9.557Z",
    transform: "translate(-200.987 -702.437)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M217.54,702.437l-5.518,9.557-5.518,9.557-5.518,9.557h11.036l5.518-9.557,4.26-7.379a1.452,1.452,0,0,1,2.515,0h0Z",
    transform: "translate(-200.987 -702.437)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M322.194,752.437l-5.518,9.557-4.265,7.388a1.446,1.446,0,0,1-2.5,0h0l1.252,2.169,5.518,9.557,5.518-9.557,5.518-9.557,5.518-9.557Z",
    transform: "translate(-309.906 -752.437)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-200.987 -701.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AF_Sign",
    transform: "translate(200.987 701.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M250.647,721.551l-5.518-9.557H234.094l-4.26,7.38a1.452,1.452,0,0,1-2.514,0l-4.261-7.38-5.518-9.557-5.518,9.557-5.518,9.557-5.518,9.557h11.036l4.26-7.379a1.452,1.452,0,0,1,2.514,0l4.26,7.379,5.518,9.557,5.518-9.557h11.036l-5.518-9.557Z",
    transform: "translate(-200.987 -702.437)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 0)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M250.647,721.551l-5.518-9.557H234.094l-4.26,7.38a1.452,1.452,0,0,1-2.514,0l-4.261-7.38-5.518-9.557-5.518,9.557-5.518,9.557-5.518,9.557h11.036l4.26-7.379a1.452,1.452,0,0,1,2.514,0l4.26,7.379,5.518,9.557,5.518-9.557h11.036l-5.518-9.557Z",
    transform: "translate(-200.987 -702.437)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 15.726,
    height: 6.627,
    transform: "matrix(0.921, -0.391, 0.391, 0.921, 13.273, 14.34)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 15.726,
    height: 6.627,
    transform: "translate(30.107 24.071) rotate(156.197)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 22.554,
    height: 7.655,
    transform: "translate(29.198 26.198) rotate(-51.73)",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M217.54,702.437l-5.518,9.557-5.518,9.557-5.518,9.557h11.036l5.518-9.557,4.26-7.379a1.452,1.452,0,0,1,2.515,0h0Z",
    transform: "translate(-200.987 -702.437)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M217.54,702.437l-5.518,9.557-5.518,9.557-5.518,9.557h11.036l5.518-9.557,4.26-7.379a1.452,1.452,0,0,1,2.515,0h0Z",
    transform: "translate(-200.987 -702.437)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 14.158,
    height: 3.259,
    transform: "translate(16.915 -0.729) rotate(59.62)",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M322.194,752.437l-5.518,9.557-4.265,7.388a1.446,1.446,0,0,1-2.5,0h0l1.252,2.169,5.518,9.557,5.518-9.557,5.518-9.557,5.518-9.557Z",
    transform: "translate(-289.087 -742.88)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(20.819 9.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M322.194,752.437l-5.518,9.557-4.265,7.388a1.446,1.446,0,0,1-2.5,0h0l1.252,2.169,5.518,9.557,5.518-9.557,5.518-9.557,5.518-9.557Z",
    transform: "translate(-309.906 -752.437)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 13.404,
    height: 3.259,
    transform: "translate(6.483 28.97) rotate(-120.38)",
    opacity: 0.5
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "M250.647,721.551l-5.518-9.557H234.094l-4.26,7.38a1.452,1.452,0,0,1-2.514,0l-4.261-7.38-5.518-9.557-5.518,9.557-5.518,9.557-5.518,9.557h11.036l4.26-7.379a1.452,1.452,0,0,1,2.514,0l4.26,7.379,5.518,9.557,5.518-9.557h11.036l-5.518-9.557Z",
    transform: "translate(0 -0.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M462.288,728.117a2.714,2.714,0,0,1,.795-1.967,2.616,2.616,0,0,1,1.947-.815,2.781,2.781,0,0,1,2.782,2.782,2.617,2.617,0,0,1-.815,1.947,2.714,2.714,0,0,1-1.967.795,2.714,2.714,0,0,1-2.742-2.742Zm10.653,2.538V701.87h3.737v28.784Zm7.315-5.129a5.709,5.709,0,0,1,.437-2.286,5.031,5.031,0,0,1,1.213-1.729,6.082,6.082,0,0,1,1.849-1.153,10.574,10.574,0,0,1,2.306-.636l5.168-.755a1.705,1.705,0,0,0,1.173-.517,1.481,1.481,0,0,0,.3-.914,3.355,3.355,0,0,0-.974-2.405,4.231,4.231,0,0,0-3.161-1.014,4.1,4.1,0,0,0-3.061,1.094,4.593,4.593,0,0,0-1.272,2.763l-3.578-.835a6.56,6.56,0,0,1,.815-2.5,6.7,6.7,0,0,1,1.69-1.968,7.873,7.873,0,0,1,2.405-1.272,9.2,9.2,0,0,1,2.922-.457,10.3,10.3,0,0,1,3.658.576,6.918,6.918,0,0,1,2.465,1.531A5.759,5.759,0,0,1,496,715.268a8.143,8.143,0,0,1,.437,2.664v9.581a20.236,20.236,0,0,0,.079,2.027,10.751,10.751,0,0,0,.159,1.113h-3.658a8.355,8.355,0,0,1-.139-.954q-.06-.6-.06-1.63a7.017,7.017,0,0,1-.835,1.073,6.354,6.354,0,0,1-1.272,1.034,6.986,6.986,0,0,1-1.769.775,8.1,8.1,0,0,1-2.286.3,6.958,6.958,0,0,1-2.644-.477,6.529,6.529,0,0,1-2.008-1.252,5.447,5.447,0,0,1-1.292-1.809A5.339,5.339,0,0,1,480.256,725.525Zm6.918,2.584a7.636,7.636,0,0,0,2.167-.3,4.493,4.493,0,0,0,1.749-.954,4.572,4.572,0,0,0,1.173-1.749,7.128,7.128,0,0,0,.437-2.644v-.875l-5.844.875a3.932,3.932,0,0,0-1.988.895,2.474,2.474,0,0,0-.8,1.968,2.692,2.692,0,0,0,.835,1.928A3.021,3.021,0,0,0,487.174,728.11Zm13.477,2.544V701.87h3.7v12.364a6.1,6.1,0,0,1,2.306-2.266,7.584,7.584,0,0,1,4.015-.994,8.8,8.8,0,0,1,3.817.775,7.8,7.8,0,0,1,2.743,2.147,9.341,9.341,0,0,1,1.67,3.2,13.325,13.325,0,0,1,.557,3.9,12.947,12.947,0,0,1-.6,4,9.654,9.654,0,0,1-1.729,3.22,8.15,8.15,0,0,1-2.783,2.167,8.646,8.646,0,0,1-3.8.8,7.524,7.524,0,0,1-3.717-.875,6.511,6.511,0,0,1-2.485-2.425v2.783Zm14.988-9.661a7.425,7.425,0,0,0-1.511-4.91,5.1,5.1,0,0,0-4.135-1.809,5.475,5.475,0,0,0-2.286.477,5.306,5.306,0,0,0-1.809,1.332,6.007,6.007,0,0,0-1.173,2.107,8.832,8.832,0,0,0-.417,2.8,9.016,9.016,0,0,0,.417,2.823,6.408,6.408,0,0,0,1.173,2.167,5.085,5.085,0,0,0,1.809,1.372,5.475,5.475,0,0,0,2.286.477,5.044,5.044,0,0,0,4.115-1.869A7.6,7.6,0,0,0,515.64,720.993Z",
    transform: "translate(-211.356)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.bc55725a1ce7f8677ff5e51cb086a011.svg";
export { ForwardRef as ReactComponent };